import React, { useContext } from "react";
import { FacebookIcon, FacebookShareButton, PinterestIcon, PinterestShareButton, RedditIcon, RedditShareButton, TwitterIcon, TwitterShareButton } from "react-share";
import { DiscordLogoIcon } from "@radix-ui/react-icons";
import Instagram from "components/molecules/Footer/instagram.svg";
import { AppContext } from "lib/contexts";
import { ImageDTO } from "types";
import * as Styled from "./SocialShare.styled";
interface SocialShareProps {
  image: ImageDTO;
  description: string;
}
const SocialShare: React.FC<SocialShareProps> = ({
  image,
  description
}) => {
  const {
    state
  } = useContext(AppContext);
  const referralCode = state.referralCode;
  const shareUrl = `https://char-gen.com/images/${image.id}${referralCode ? `?referralCode=${referralCode}` : ""}`;
  const imageUrl = image.image;
  const twitterDescription = `${description} made with @char_genAI\n`;
  const redditDescription = `${description} made with CharGen`;
  const instagramDescription = `${description} : ${imageUrl} | @chargen_ai`;
  return <Styled.ShareContainer data-sentry-element="unknown" data-sentry-component="SocialShare" data-sentry-source-file="index.tsx">
            <FacebookShareButton url={shareUrl} data-sentry-element="FacebookShareButton" data-sentry-source-file="index.tsx">
                <FacebookIcon size={32} round data-sentry-element="FacebookIcon" data-sentry-source-file="index.tsx" />
            </FacebookShareButton>
            <TwitterShareButton url={shareUrl} title={twitterDescription} hashtags={["DNDArt", "AIArt", "CharGen"]} data-sentry-element="TwitterShareButton" data-sentry-source-file="index.tsx">
                <TwitterIcon size={32} round data-sentry-element="TwitterIcon" data-sentry-source-file="index.tsx" />
            </TwitterShareButton>
            <RedditShareButton url={shareUrl} title={redditDescription} data-sentry-element="RedditShareButton" data-sentry-source-file="index.tsx">
                <RedditIcon size={32} round data-sentry-element="RedditIcon" data-sentry-source-file="index.tsx" />
            </RedditShareButton>
            <PinterestShareButton url={shareUrl} media={imageUrl} description={description} data-sentry-element="PinterestShareButton" data-sentry-source-file="index.tsx">
                <PinterestIcon size={32} round data-sentry-element="PinterestIcon" data-sentry-source-file="index.tsx" />
            </PinterestShareButton>
            <Styled.InstagramButton href={`https://www.instagram.com/?url=${encodeURIComponent(shareUrl)}&caption=${encodeURIComponent(instagramDescription)}`} target="_blank" rel="noreferrer" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.Icon priority src={Instagram} alt="InstagramIcon" data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
            </Styled.InstagramButton>
            <Styled.DiscordButton href={"https://discord.gg/SsQ7NBUNRE"} target="_blank" rel="noreferrer" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <DiscordLogoIcon className="w-6 h-6" data-sentry-element="DiscordLogoIcon" data-sentry-source-file="index.tsx" />
            </Styled.DiscordButton>
        </Styled.ShareContainer>;
};
export default SocialShare;